<template>
    
  <div class="main">
    <ProgressBar/>


    <h2 class="end-title">Bedankt, je bent mijn reddende engel!</h2>
  


    
      <div class="heart-white" @click="blueTransition()">
        <!-- hearts " -->
        <div class=" hearts animate__animated animate__heartBeat animate__infinite"> 
    
          <div class="heart-wrapper heart-main">
            <svg xmlns="http://www.w3.org/2000/svg" width="80" height="60" viewBox="0 0 80 60">
              <g id="heart2" transform="translate(-3.736 -32.136)">
                <g id="Group_973" data-name="Group 973" transform="translate(3.736 32.136)">
                  <path id="XMLID_2_" d="M76.335,37.334c-8.014-6.955-20.022-7.145-27.575.734-1.97,2.065-3.953,4.116-5.922,6.181-2.105-2.024-4.224-4.048-6.33-6.072-7.362-7.063-20.688-7.186-27.575.734-6.955,8.014-7.145,20.022.734,27.575q9.638,9.25,19.3,18.5A14.286,14.286,0,0,0,30,85.976c7.362,7.063,20.688,7.186,27.575-.734q9.739-10.167,19.492-20.335C84.132,57.533,84.254,44.207,76.335,37.334Z" transform="translate(-3.736 -32.136)" fill="var(--color-white)"/>
                </g>
              </g>
            </svg>
          </div>
  
        </div>
        <p class="instruction">OPNIEUW ?</p>





      </div>

      <a href="https://jaja.be/"><p class="jaja">Powered by JaJa.</p></a>

      <div id="circle-blue"></div>

  
  </div>
  </template>
  
  
  
  <script>
  import ProgressBar from "./progress-bar.vue";
  export default {
    name: 'end-red',
    components: {
        ProgressBar,
    },
    
    methods:{
        async blueTransition() {
          let cirlce = document.getElementById("circle-blue");
        cirlce.style.opacity=1;
        cirlce.style.transform="scale(55,55)";
        await new Promise(resolve => setTimeout(resolve, 1000));
        this.$router.push({ path: '/' });
    }

    },
    mounted() {
    this.$gtm.trackView('mijn reddende engel!', '/end');
  }
    }
  </script>
  
  <style scoped>
  .main{
    background-color: var(--color-red);
  }

  h2{
    color: var(--color-white);
    font-weight: 700;
    font-size: 25px;
    /* margin: 10%;
    margin-top: 30%; */
    opacity: 0;
    animation: appear 2s ease-in-out 0.3s forwards;
  }

  .end-title{
    text-align: center;
    margin-top: 200px;
    max-width: 560px;
    margin-left: auto;
    margin-right: auto;
  }

  .heart-white{
    cursor: pointer;
    max-width: 90px;
    height: 100px;
    position: absolute;
    top: 400px;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;

    opacity: 0;
    animation: appear 1s ease-in-out forwards;
  }

  .hearts{
    z-index: 10;

    transform-origin: center;
  }

  .instruction{
    text-align: center;
    color: var(--color-white);
    margin: 0;
    opacity: 0;
    margin-top: 20px;
    font-size: 15px;
    animation: appear 2s ease-in-out 2s forwards;
    max-width: fit-content;
  }

  .jaja{

    cursor: pointer;
    max-width: 90px;
    height: 100px;
    position: absolute;
    bottom: 1px;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;

    opacity: 0;
    /* text-align: center; */
    color: var(--color-white);

    font-size: 15px;
    animation: appear 2s ease-in-out 2s forwards;
    max-width: fit-content;
  }

  #circle-blue{
  position: absolute;
  opacity: 0;
  z-index: 30;
  
  bottom: 40%;
  background-color: var(--color-blue);
  border-radius: 50%;

  width: 50px;
  height: 50px;

  left: 48%;

  transition: transform 0.9s ease-in;

  
  }

  @media (min-width: 900px){
    
    .heart-white{
      top: 500px;
    }
    
    h2{
      font-size: 50px;
      font-weight: 600;
    }


  }
  </style>
  